module.exports = __webpack_public_path__ + "img/open.5f627a3.svg";